<template>
  <div>
    <div class="selectableItem  d-flex flex-column justify-space-around" @click="setValue" style="cursor: pointer"
         :id="`${data.key}_step`">
      <div class="activeArea  d-flex flex-column justify-space-around" v-if="stepData[primaryKey][keyStep] == data.val">
        <v-icon color="white" small>mdi-check</v-icon>
      </div>
      <div class="imageArea" v-if="data.image">
        <img :src="data.image" alt="">
      </div>
      <div>
        {{ data.title }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object,
    keyStep: String,
    stepData: Object,
    primaryKey: String,
  },
  methods: {
    setValue() {
      this.$emitEvent('setStepValue', {
        key: this.keyStep,
        value: this.data.val,
        nextStep: true
      })
    }
  }
}
</script>

<style scoped>
.selectableItem {
  width: 100%;
  min-height: 132px;
  font-size: 10pt;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  background: url("../../assets/matchMaking/backitem.png") no-repeat;
  background-size: cover;
  position: relative;
  border: solid 2px #d1dcff;
}

.imageArea img {
  width: 120px;
}

.activeArea {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4576d8;
}

.activeItem {
  border: 3px solid #4576d8;
}
</style>